import { render, staticRenderFns } from "./homeTodo.vue?vue&type=template&id=b481ca52&scoped=true&"
import script from "./homeTodo.vue?vue&type=script&lang=js&"
export * from "./homeTodo.vue?vue&type=script&lang=js&"
import style0 from "./homeTodo.vue?vue&type=style&index=0&id=b481ca52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b481ca52",
  null
  
)

export default component.exports